<template>
  <div>
    <el-card>
      <el-select
        class="m-w"
        v-model="EnterpriseListValue"
        placeholder="请选择企业"
        @change="Get_PostSelectInfo"
      >
        <el-option
          v-for="item in EnterpriseList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <el-select class="m-w" v-model="PostListValue" placeholder="请选择岗位">
        <el-option
          v-for="item in PostList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <el-select
        class="m-w"
        v-model="StatusListValue"
        placeholder="请选择审核状态"
      >
        <el-option
          v-for="item in StatusList"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <el-select
        class="m-w"
        v-model="EvaluateListValue"
        placeholder="请选择评价状态"
      >
        <el-option
          v-for="item in EvaluateList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        style="width: 150px"
        class="m-w"
        v-model="StudentName"
        placeholder="请输入学生名称"
      ></el-input>
      <el-input
        style="width: 150px"
        class="m-w"
        v-model="Phone"
        placeholder="请输入手机号"
      ></el-input>
      <el-button type="primary" @click="GetEP_DeliverInfoByPage"
        >查询</el-button
      >

      <el-button @click="clearData">重置</el-button>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="tui-card" v-show="isChange.length != 0">
        <div class="flex-items">
          <i class="el-icon-warning"></i>
          <div class="title">
            已选择 <span>{{ isChange.length }}</span> 项
          </div>
        </div>
        <div class="clear">清空</div>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="StudentName"
          width="150"
          label="学生姓名"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="StudyYearName"
          width="150"
          label="学届"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="GradeName"
          width="150"
          label="年级"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="ClassName"
          width="150"
          label="班级"
          align="center"
        >
        </el-table-column>

        <el-table-column
          prop="MaskName"
          width="150"
          label="所属"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="PostName" label="岗位名称" align="center">
        </el-table-column>
        <el-table-column
          prop="Phone"
          width="100"
          label="联系电话"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column prop="Detail" label="介绍" align="center">
        </el-table-column> -->
        <el-table-column label="附件地址" align="center" width="100">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-download"
              circle
              type="primary"
              @click="onClickDownLoad(scope.row.FileUrl)"
            ></el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="StatusName"
          width="100"
          label="审核状态"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="EvalStatusName"
          width="100"
          label="评价状态"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="EvalDetail" label="评价内容" align="center">
        </el-table-column>
        <el-table-column
          width="100"
          prop="EvalLevelEnumName"
          label="评价级别"
          align="center"
        >
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center; padding: 20px 0 0 0"
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
import {
  Get_MaskSelectInfo,
  Get_PostSelectInfo,
  GetCheckStatusSelectInfo,
  GetEP_DeliverInfoByPage,
} from "../../api/api";
export default {
  data() {
    return {
      EvaluateList: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "待评价",
        },
        {
          value: "2",
          label: "已评价",
        },
      ],
      EvaluateListValue: "0",
      tableData: [],
      isChange: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      EnterpriseList: [],
      EnterpriseListValue: "",
      PostList: [],
      PostListValue: "",
      StatusList: [],
      StatusListValue: "",
      StudentName: "",
      Phone: "",
    };
  },
  async created() {
    await this.Get_MaskSelectInfo();
    await this.GetCheckStatusSelectInfo();
    await this.GetEP_DeliverInfoByPage();
  },
  methods: {
    onClickDownLoad(val) {
      window.open(val, "_blank");
    },
    clearData() {
      this.EnterpriseListValue = "";
      this.PostListValue = "";
      this.StudentName = "";
      this.Phone = "";
      this.StatusListValue = "";
      this.EvaluateListValue = "0";
      this.GetEP_DeliverInfoByPage();
    },
    async GetEP_DeliverInfoByPage() {
      let res = await GetEP_DeliverInfoByPage({
        EP_MaskId:
          this.EnterpriseListValue == "" ? 0 : this.EnterpriseListValue,
        EP_PostId: this.PostListValue == "" ? 0 : this.PostListValue,
        StudentName: this.StudentName,
        Phone: this.Phone,
        Status: this.StatusListValue == "" ? 0 : this.StatusListValue,
        EvalStatus: this.EvaluateListValue,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: "",
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    async GetCheckStatusSelectInfo() {
      let res = await GetCheckStatusSelectInfo();
      if (res.data.success) {
        this.StatusList = res.data.response;
      }
    },
    async Get_MaskSelectInfo() {
      let res = await Get_MaskSelectInfo();
      if (res.data.success) {
        this.EnterpriseList = res.data.response;
      }
    },
    async Get_PostSelectInfo() {
      let res = await Get_PostSelectInfo({
        Id: this.EnterpriseListValue == "" ? 0 : this.EnterpriseListValue,
      });
      if (res.data.success) {
        this.PostList = res.data.response;
      }
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetEP_DeliverInfoByPage();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetEP_DeliverInfoByPage();
    },
  },
};
</script>
<style lang="less" scoped>
.m-w {
  margin-right: 10px;
}
.tui-card {
  width: 100%;
  height: 40px;
  background-color: rgba(230, 247, 255, 1);
  color: rgba(16, 16, 16, 1);
  border: 1px solid rgba(186, 231, 255, 1);
  margin-bottom: 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  i {
    color: #1890ff;
  }
  .clear {
    color: #1890ff;
  }
  .title {
    padding-left: 10px;
    color: #101010;
    font-size: 14px;
    font-weight: 600;
    span {
      color: #1890ff;
      padding: 0 5px;
    }
  }
}
</style>